<template>
	<div>
		<a-form-model ref="addForm"  layout="inline"  :model="theObj" :rules="rules">
			<a-form-model-item label="片区" prop="departmentName">
				<a-input  v-model="theObj.departmentName" style="width:13rem"/>
			</a-form-model-item>
			<a-form-model-item label="备注">
				<a-input  v-model="theObj.remark" style="width:13rem"/>
			</a-form-model-item>
		</a-form-model>
		<a-table size="small" :columns="columns" :data-source="list" bordered   rowKey="pId" :pagination="false"
					  style="margin-top: 1.25rem;" :scroll="{y:600}" :row-selection="rowSelectHandler">
		</a-table>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	const columns = [
		{
			title: '小区',
			dataIndex: 'neighborName',
			width:200,
			ellipsis :true,
		},
		{
			title: '地址',
			dataIndex: 'neighborAddr',
			width:200,
			ellipsis :true,
		},
	];
	export default{
		data(){
			return{
				columns,
				submitFlag:false,
				theObj:{},
				list:[],
				rules:{
					departmentName:[{required:true,message:'请输入片区',trigger: 'blur'}],
				},
				selectedList:[],
			}
		},
		methods:{
			onClose:function(flag){
				this.$emit('cancelAdd');
				if(flag){
					this.$emit('refreshList');
				}
			},
			onSubmit:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						if(this.selectedList.length == 0){
							this.$message.error('请选择小区信息');
						}else{
							this.doSubmit();
						}
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
				this.submitFlag = true;
				this.theObj.neighborIds =this.selectedList.join(',');
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_ADD_URL);
				this.Api.fetchPostWithForm(url,this.theObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('新增片区成功');
						this.onClose(true);
					}else{
						this.$message.error(msg);
					}
					
				}).catch((error)=>{
					this.submitFlag = false;
					console.log(error);
				});
			},
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_NEIGHBORS_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.queryDataList();
		},
		computed:{
			rowSelectHandler:function(){
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						this.selectedList = selectedRowKeys;
					},
				}
			}
		}
		
	}
</script>

<style scoped="scoped">
</style>
